import Image from "next/image";
import Social from "./social";
import CtaBtn from "@/components/ui/cta-btn";
import { fetchData, SITE_URL } from "@/utils/api";
import { MEDIA_BASE_URL } from "@/utils/api";
import Link from "next/link";
import { useEffect, useState } from "react";
import { parseCookies } from "nookies";
import LoginForm from "@/components/product-gallery-page/section/loginForm";
import Enquiry from "./enquiry";

const Product_Slider_Details = ({ productDetailsUrl, productDetails }) => {
  const [user, setUser] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [favoutiteBtnName, setFavoutiteBtnName] = useState(null);
  const [showMobilePopup, setShowMobilePopup] = useState(false);

  useEffect(() => {
    const cookies = parseCookies();
    const user = JSON.parse(cookies.user || "{}");
    setUser(user);
    // Check if favourite_products is defined and is an array
    if (
      Array.isArray(productDetails?.favourite_products) &&
      productDetails.product_code
    ) {
      if (
        productDetails?.favourite_products.includes(productDetails?.product_code)
      ) {
        setFavoutiteBtnName("Remove");
      } else {
        setFavoutiteBtnName("Favourite");
      }
    } else {
      // Handle the case where favourite_products is not defined
      setFavoutiteBtnName("Favourite");
    }
  }, [productDetails]);

  // Run only once after the component is mounted
  const handleAddToFavorites = async (event) => {
    event.preventDefault(); // Prevent the default behavior of the anchor tag
    setFavoutiteBtnName("Submitting...");
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("product_code", productDetails.product_code);
      formDataToSend.append("user_id", user.id);
      formDataToSend.append("first_name", user.first_name);
      formDataToSend.append("last_name", user.last_name);
      formDataToSend.append("email", user.email);
      formDataToSend.append("contact_number", user.contact_number);
      formDataToSend.append("company_name", user.company_name);
      formDataToSend.append("country", user.country);
      formDataToSend.append("city", user.city);
      formDataToSend.append("language", user.language);
      formDataToSend.append("user_type", user.city);
      formDataToSend.append("type", 'tiles');
      formDataToSend.append("endpoint", "tiles/products/add_to_favorites");
      const response = await fetch("/api/form/handler", {
        method: "POST",
        body: formDataToSend,
      });
      const responseData = await response.json();
      if (!response.ok) {
        throw new Error("Failed to add to favorites.");
      }
      setErrorMessage(null);
      setTimeout(() => {
        setSuccessMessage(responseData.message);
        if (responseData.data.includes(productDetails.product_code)) {
          setFavoutiteBtnName("Remove");
        } else {
          setFavoutiteBtnName("Favourite");
        }
        setTimeout(() => {
          setSuccessMessage(null); // Hide the success message
        }, 3000);
      }, 2000); // 2000 milliseconds = 2 seconds
    } catch (error) {
      setShowMobilePopup(true);
      setSuccessMessage(null);
      setErrorMessage(error.message);
    }
  };

  const mediaBaseUrl = MEDIA_BASE_URL;

  const handleClosePopup = (popupName) => {
    setShowMobilePopup(false);
  };

  const application = productDetails?.application.split(", ")

  const locations = ['Living Room', 'Bathroom', 'Bedroom'];


  return (
    <div>
      <div className="mb-5 lg:mb-[2.5vw]">
        {productDetails?.product_name && <h1 className="text-xl sm:text-2xl md:text-3xl tracking-wide lg:text-[2.7vw] lg:tracking-[0.135vw] lg:mb-[2.5vw] font-secondary text-black">
          {productDetails.product_name}
        </h1>}
        <p className="mb-3 lg:mb-[1vw]">
          <strong className="text-black">Short Description:</strong>
        </p>
        {productDetails?.description && <p>{productDetails.description}</p>}
      </div>
      <div className="flex flex-wrap gap-5 md:items-center mb-5 lg:mb-[2.5vw]">
        <div>
          <strong className="text-black">Collection : </strong>
          <span className="text-black d-inline-block">
            {productDetails?.collection_name ? (
              <Link
                href={`${productDetails?.collection_link}`}
                className="cursor-pointer"
              >
                {productDetails?.collection_name.charAt(0).toUpperCase() +
                  productDetails?.collection_name.slice(1).toLowerCase()}
              </Link>
            ) : (
              ""
            )}
          </span>
        </div>
      </div>
      {productDetails?.application_links?.length > 0 && <div className="flex flex-wrap gap-5 md:items-center mb-5 lg:mb-[2.5vw]">
        <div>
          <strong className="text-black">Application: </strong>
          {productDetails?.application_links?.map((item, i) => <Link href={item.link} className="text-black capitalize" key={item.title}>
            {item.title}
            {i < productDetails?.application_links?.length - 1 ? ',  ' : ''}
            {/*productDetails.application
              ? productDetails.application.charAt(0).toUpperCase() + productDetails.application.slice(1)
              : ""*/}
          </Link>)}
        </div>
      </div>}

      {productDetails?.location_links?.length > 0 && <div className="flex flex-wrap gap-5 md:items-center mb-5 lg:mb-[2.5vw]">
        <div>
          <strong className="text-black">Suitable For: </strong>
          {productDetails?.location_links?.map((item, i) => <Link href={item.link} className="text-black" key={item.title}>
            {item.title}
            {i < productDetails?.location_links.length - 1 ? ',  ' : ''}

          </Link>)}
        </div>
      </div>}

      <div className="flex flex-wrap gap-5 md:items-center mb-5 lg:mb-[2.5vw]">
        {productDetails?.collection_logo?.trim() ? (
          <div>
            <div className="flex-[0_0_auto]">Collection</div>
            <div className="flex flex-wrap gap-5 lg:gap-[1vw] flex-[1_0_0]">
              <div className="w-[140px] lg:w-[10vw] flex-[0_0_auto]">
                <Image
                  src={`${mediaBaseUrl}${productDetails?.collection_logo}`}
                  width={100}
                  height={60}
                  alt="Product Details"
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <div className="flex flex-wrap gap-2 lg:gap-[.5vw] mb-5 lg:mb-[2.5vw]">
        <CtaBtn
          customClass={`bg-white border-black !text-black`}
          name={favoutiteBtnName}
          target=""
          link={"#"}
          callFunction={handleAddToFavorites}
          svgIcon={
            favoutiteBtnName === "Remove"
              ? `/images/icons/wishlist_fill.svg`
              : "/images/icons/wishlist.svg"
          }
        />

        {productDetails?.catalogue?.trim().toLowerCase().endsWith('.pdf') ? (
          <CtaBtn
            customClass="bg-white border-black !text-black"
            name="Download Catalog"
            target="_blank"
            link={`${mediaBaseUrl}${productDetails?.catalogue}`}
          />
        ) : null}

        <Enquiry product_code={productDetails?.product_code} type='tiles' />
        {errorMessage && <label className="text-red">{errorMessage}</label>}
        {successMessage && (
          <label className="text-green">{successMessage}</label>
        )}
      </div>

      <div className="sm:flex sm:flex-wrap items-center">
        {productDetails?.view_link?.trim() ? (
          <div className="w-[130px] lg:w-[200px] sm:pe-5 lg:pe-[2.5vw] sm:border-r-[1px] sm:border-[#58585A] sm:border-solid mb-5 sm:mb-0">
            <a
              href={productDetails?.view_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <Image
                  src={`/images/product_details/360_deg.gif`}
                  width={150}
                  height={50}
                  alt="360 deg"
                />
              </div>

              {/* <div className="text-center text-black">
                <strong className="block leading-none font-bold text-[20px]">
                  360
                </strong>
                <span className="block leading">View</span>
              </div> */}
            </a>
          </div>
        ) : null}
        <div
          className={` ${productDetails?.view_link?.trim() ? "sm:ps-5 lg:ps-[2.5vw]" : ""
            }`}
        >
          <span className="inline-block me-5 font-secondary text-black">
            Share on:
          </span>
          <div className="inline-block">
            <Social productDetailsUrl={productDetailsUrl} />
          </div>
        </div>
      </div>
      {showMobilePopup && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-[1000000]">
          <div className="relative bg-[#363435] text-center mx-5 p-8 w-full max-w-[600px] lg:max-w-[43vw] z-[99]">
            <LoginForm handleClosePopup={handleClosePopup} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Product_Slider_Details;
